import React, { Fragment } from 'react';
import { Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const AccountStatus = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { status, reason, onRequestProfileReview } = props;

  return (
    <div className={classes.statusContainer}>
      {status === 'verified' && (
        <Typography
          className={classes.statusText}
          variant="body1"
          dangerouslySetInnerHTML={{
            __html: t(`components.ProfileForm.accountStatus.verified`),
          }}
        />
      )}
      {status !== 'verified' && (
        <Fragment>
          <Typography className={classes.statusText} variant="body1">
            {t(`components.ProfileForm.accountStatus.${status}.first`)} <b>{reason}</b>
          </Typography>
          <Typography className={classes.statusText} variant="body1">
            {t(`components.ProfileForm.accountStatus.${status}.second`)}
          </Typography>
          <Button onClick={onRequestProfileReview}>{t('components.ProfileForm.accountStatus.button')}</Button>
        </Fragment>
      )}
    </div>
  );
};

AccountStatus.propTypes = {
  onRequestProfileReview: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  reason: PropTypes.string.isRequired,
};

export default AccountStatus;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/Profile/components/ProfileForm/components/AccountStatus/AccountStatus.js